<template>
  <v-row align="center" justify="center" class="text-center fill-height">
    <div>
      <img src="../../assets/generic-error.png" alt="Error" class="mb-4" />
      <h1 class="headline primary--text">Something wrong here...</h1>
      <p class="subheading">
        Sorry, we're having some technical issues (as you can see)
        <br />
        Try to refresh the page, sometime works ;)
      </p>
    </div>
  </v-row>
</template>

<script>
export default {
  name: 'GenericError'
}
</script>

<style lang="scss" scoped>
img {
  max-width: 80%;
}
</style>
